<h2 mat-dialog-title>
  @if (icon) {
    @if (isStringIcon) {
      <mat-icon>{{ icon }}</mat-icon>
    } @else if (isObjectIcon) {
      <svg class="icon-24"><use [attr.href]="'assets/images/ok-icons-sprite.svg#' + iconName"></use></svg>
    }
  }
  {{ title }}
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div>
  <div mat-dialog-content class="dialog__content">
    <p [innerHTML]="text"></p>
  </div>
  <div mat-dialog-actions>
    @if (identifier) {
      <div class="unit-identifier">
        <span>{{ identifier.title }}:</span>
        {{ identifier.value }}
      </div>
    }
    <button mat-button (click)="close()">{{ denyText }}</button>
    <button mat-raised-button color="primary" (click)="confirm()">{{ confirmText }}</button>
  </div>
</div>
